import isApiError from "@insite/client-framework/Common/isApiError";
import {
    ApiHandler,
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { DeleteShipParmsModel, deleteShipTo, DeleteShipToParameter } from "@tSurya/Services/DeleteShipService";

type HandlerType = ApiHandler<DeleteShipToParameter & HasOnSuccess & HasOnError, DeleteShipParmsModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await deleteShipTo(props.apiParameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult as any);
};

// export const ExecuteOnErrorCallback: HandlerType = props => {
//     props.parameter.onError?.(props.apiResult as any);
// };

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const deleteShipToAddress = createHandlerChainRunner(chain, "deleteShipToAddress");
export default deleteShipToAddress;
